import { isNull, isNumber } from 'lodash';
import React, { useRef } from 'react';
import { SliderInput } from '@meitu/saas-ui';
import { IBrushLayerProps } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { isIntl } from '@/react-process-env';

export const RadiusFeature: React.FC<{
    id: string;
    onAfterChange?: Function;
}> = React.memo(({ id, onAfterChange }) => {
    const { $t } = useLocaleStore();
    const originVal = useRef<number | null>(null);

    const radius = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { radius } = layer.data as IBrushLayerProps;
        return radius;
    });

    if (isNull(radius)) return null;

    return (
        <div className="c-brush-panel__item c-brush-panel__item-width">
            <LabelAction title={$t((v) => v.panel.brushPanel.radius)} align={true}>
                <div style={{ width: isIntl ? 152 : 174 }}>
                    <SliderInput
                        value={radius}
                        max={100}
                        min={0}
                        showStepBtn={true}
                        type="horizontal"
                        onChange={(val: number) => {
                            if (originVal.current === null) {
                                originVal.current = radius;
                            }
                            editor.brushLayer.setRadius(id, val);
                        }}
                        onAfterChange={(val: number) => {
                            if (isNumber(originVal.current)) {
                                editor.brushLayer.setRadius(id, val, originVal.current);
                            }
                            originVal.current = null;
                            onAfterChange?.(77);
                        }}
                    />
                </div>
            </LabelAction>
        </div>
    );
});
